
import _ from 'lodash';
import { Message } from 'element-ui';
import { distinctTasksByLngLat, pointsUnion, pointsIntersectDiffDiff, tasksAt, taskToPoint, distinctTasks,hasDifferentVal  } from '../utils/helpers';
import { verifyLBX,appointmentCheck  } from '@/modules/transport/otp/utils/dispatchCenter';

// 点按状态分类不同的颜色
const seperatePoints = (points) => {
    const pointsByCount = [];
    // 先根据客户名称进行归类
    const pointsNew = points.reduce((obj, item) => {
        const name = item.customerName;
        if (!obj[name]) {
            obj[name] = [];
        }
        obj[name].push(item);
        return obj;
    }, {});
    // 再在客户下根据状态分为 待调度 跟非待调度
    const customerNameList = Object.values(pointsNew);
    customerNameList.forEach(item => {
        const result = item.reduce((acc, curr) => {
            if (+curr.taskStatus === 0) {
                acc[0].push(taskToPoint(curr));
            } else {
                acc[1].push(taskToPoint(curr));
            }
            return acc;
        }, [[], []]);

        pointsByCount.push(result);
    });
    return pointsByCount;
};

// 逻辑类
export class MapVdcLogic {
    _tasksOrderMap = new Map();
    _tasksOrderInc = 0;

    taskOrder (task) {
        return this._tasksOrderMap.get(task.taskNo);
    }

    markTaskOrder (task) {
        if (!this._tasksOrderMap.has(task.taskNo)) {
            this._tasksOrderInc += 1;
            this._tasksOrderMap.set(task.taskNo, this._tasksOrderInc);
        }
    }

    toResizeFloatWindow () { }

    /**
     * 排车校验
     */
    addSelectedPointsPreValidate (selectedTasks, tasksAtPoints,SiteCodeWhiteList) {

        const checkedTasks = tasksAtPoints.concat(selectedTasks);
        // 非待调度时不能进行线路规划 第一次选
        if (tasksAtPoints.some(v => v.taskStatus !== 0)) {
            Message.warning('运输单状态为非待调度时不能进行线路规划');
            return false;
        }
        // 混选
        if (checkedTasks.some(v => v.taskStatus === 0)) {
            if (!checkedTasks.every(v => v.taskStatus === 0)) {
                Message.warning('运输单状态为非待调度时不能进行线路规划');
                return false;
            }
        }
        if (checkedTasks.some(v => v.projectClassify === 'QCO')) {
            if (!checkedTasks.every(v => v.projectClassify === 'QCO')) {
                Message.warning('快消单和非快消单不能混合进行线路规划!');
                return false;
            }
        }
        if (checkedTasks.length > 100) {
            Message.warning('最多选中点数不可超过100个点');
            return false;
        }

        const planOrderVanFlag = checkedTasks.every(e =>  +e.planOrderFlag === 1 )
        const planVanAndRealFlag = checkedTasks.some(e =>  +e.planOrderFlag === 1 )

        // if (planVanAndRealFlag&&!planOrderVanFlag) {
        //    Message.warning('模糊订单和非模糊订单不能同时排车');
        //    return false;
        // }
        if (planOrderVanFlag) {
           if (hasDifferentVal(checkedTasks,'inOutType')) {
             Message.warning('模糊订单只支持同类型单据排车');
             return false;
           }
        } else {
            if (
                (!checkedTasks.some(obj => obj.inOutType === 'OUT' || obj.inOutType === 'YS') && hasDifferentVal(checkedTasks,'inOutType')) ||
                (!checkedTasks.every(obj => obj.inOutType === 'OUT' || obj.inOutType === 'YS'))
            )
            {
                Message.warning('非模糊订单只支持 同类型 或 纯运输和销售出库类 订单排车');
                return false;
            }
        }

        if (!checkedTasks.every(obj => obj.inOutType === 'OUT' || obj.inOutType === 'YS')) {
            if (hasDifferentVal(checkedTasks,'warehouseGroup')) {
                Message.warning('存在不同仓库分组的运输单');
                return false;
            }
        }

        if (checkedTasks.every(obj => obj.inOutType === 'OUT') && hasDifferentVal(checkedTasks, 'warehouseGroup')) {
            Message.warning('存在不同仓库分组的销售出库单');
            return false;
        }

        if (checkedTasks.some(obj => +obj.freightBasis === 40) && !checkedTasks.every(obj => +obj.freightBasis === 40)) {
            Message.warning('搬仓订单与非搬仓订单不允许混排！');
            return false;
        }

        if (checkedTasks.some(obj => +obj.carrierVisibleFlag) && hasDifferentVal(checkedTasks,'carrierVisibleFlag')) {
            Message.warning('已下发运单不能与未下发运单同时排车');
            return false;
        }

        if (checkedTasks.some(obj => +obj.transUnitCode) && hasDifferentVal(checkedTasks,'transUnitCode')) {
            Message.warning('多个下游会计主体不允许同时排车');
            return false;
        }

        if (tasksAtPoints.find(obj => obj.distributionWhCode)) {
            Message.warning('勾选任务中存在继续分拨订单，请确认是否继续！')
        }
        let verifyLBXRes = verifyLBX(tasksAtPoints, selectedTasks);
         const customerOrderNoList = appointmentCheck(verifyLBXRes, SiteCodeWhiteList);
        if (customerOrderNoList.length) {
            Message.warning(`以下客户订单号需要先预约才能排车:${customerOrderNoList}`)
            return false;
        }
        return true;
    }

    // 选中坐标点逻辑  tasksAtPoints 当前选中TK单
    computeSelectedPoints (points, tasksAtPoints, comp) {
        // _toRemove  不能删掉 删掉无法选中    _toRemove 删除, keep存储, toAdd新增
        const [_toRemove, keep, toAdd] = pointsIntersectDiffDiff(comp.selectedPoints, points); // pointsIntersectDiffDiff 取交并集

        comp.selectedPoints = pointsUnion(keep, toAdd); // pointsUnion 去重 选中point

        const allSelectedTasks = [...comp.allSelectedTasks]; //  选中TK单

        comp.selectedTasks = this.computeSelectedTasks(comp, tasksAtPoints, allSelectedTasks);
    }
    // 处理TK单逻辑
    computeSelectedTasks (comp, tasksAtPoints, allSelectedTasks) {
        return _.flatten(comp.selectedPoints.map(p => {
            const tasks = tasksAt(p.lat, p.lng, distinctTasks(allSelectedTasks.concat(tasksAtPoints)));
            for (const task of tasks) {
                this.markTaskOrder(task);
            }
            return tasks;
        }));
    }

    // -- 请确保入参两个任务列表没有共同元素
    combineSelectedTasks (_tasksA, _tasksB) {
        const sortFn = [t => this.taskOrder(t)];
        const [tasksA, tasksB] = [_.sortBy(_tasksA, sortFn), _.sortBy(_tasksB, sortFn)];
        const tasks = [];
        let ia = 0; let ib = 0;
        while (ia < tasksA.length && ib < tasksB.length) {
            const ta = tasksA[ia];
            ta._selectedMode = 'selected';
            const tb = tasksB[ib];
            tb._selectedMode = 'tempSelected';
            if (this.taskOrder(ta) < this.taskOrder(tb)) {
                tasks.push(ta);
                ia += 1;
            } else {
                tasks.push(tb);
                ib += 1;
            }
        }
        while (ia < tasksA.length) {
            tasksA[ia]._selectedMode = 'selected';
            tasks.push(tasksA[ia]);
            ia += 1;
        }

        while (ib < tasksB.length) {
            tasksB[ib]._selectedMode = 'tempSelected';
            tasks.push(tasksB[ib]);
            ib += 1;
        }
        return tasks;
    }

    // 绘制选择预览点
    previewSelectedPoints (points, mapCtrl, comp) {
        mapCtrl.drawSelectedPoints(comp.selectedPoints, points);
    }

    // 地图选点逻辑
    addSelectedPoints (points, mapCtrl, comp,SiteCodeWhiteList) {

        // 选中当前TK
        const tasksAtPoints = _.flatten(points.map(p => {
            return tasksAt(p.lat, p.lng, comp.totalDataAndTotalTargetData);
        }));

        // 根据已选TK单存在取消反选
        const allSelectedTaskNoSet = new Set(comp.selectedTasks.map(t => t.taskNo));
        const tasks = tasksAtPoints.filter(t => !allSelectedTaskNoSet.has(t.taskNo));

        // 校验排车限制 2期不做校验
        if (!this.addSelectedPointsPreValidate(comp.allSelectedTasks, tasks,SiteCodeWhiteList)) {
            return;
        }

        // 交并集去重等逻辑处理
        this.computeSelectedPoints(points, tasks, comp, mapCtrl);

        // 重新绘制“选择点"
        mapCtrl.drawSelectedPoints(comp.selectedPoints, []);
    }
    seperatePointsFromTasks (tasks) {
        const distinctedTasks = distinctTasksByLngLat(tasks); // 点状校验去重
        // const [toDispatch, toArrive, toLoad, toSend, toNo] = seperatePoints(distinctedTasks); //  对应坐标点
        const result = [distinctedTasks.map(task => taskToPoint(task)), seperatePoints(distinctedTasks), distinctedTasks];
        return result;
    }
}
